import React from 'react';
import { Button } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../../actions';

const FontFamily = () => {
  const dispatch = useDispatch();
  const currentFontFamily = useSelector(state => state.design.fontFamily);

  const onToggle = e => {
    dispatch(designActions.setSidePanel('fontFamily'));
    e.preventDefault();
  };

  return (
    <Button
      content={currentFontFamily ? currentFontFamily.split('--')[0].replaceAll('__', ' ') : '--'}
      onMouseDown={onToggle}
    />
  );
};

export default FontFamily;
